<template>
  <div>
    <h3 style="text-transform: uppercase; margin-bottom: 12px;">
      Overview
    </h3>
    <div
      style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;"
    >
      <campaign-detail label="Type" :value="type"></campaign-detail>
      <campaign-detail label="Office" :value="agency"></campaign-detail>
      <campaign-detail label="Package" :value="packageTitle"></campaign-detail>
      <campaign-detail label="Start Date" :value="startDate"></campaign-detail>
      <campaign-detail label="End Date" :value="endDate"></campaign-detail>
      <campaign-detail
        label="Property"
        :value="property || 'N/A'"
      ></campaign-detail>
      <campaign-detail
        label="Booked By"
        :value="bookedBy || 'N/A'"
      ></campaign-detail>
      <campaign-detail label="Booked At" :value="bookedAt"></campaign-detail>
      <campaign-detail
        label="Status"
        :value="status || 'N/A'"
      ></campaign-detail>
      <template v-for="campaign in associatedCampaigns">
        <campaign-detail
          :key="campaign.id"
          :label="'Associated ' + campaign.type + ' ID'"
          :value="campaign.id"
        ></campaign-detail
      ></template>
    </div>
  </div>
</template>

<script>
import CampaignDetail from './CampaignDetail.vue';
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';
export default {
  components: {CampaignDetail},
  data() {
    return {
      associatedCampaigns: [],
    };
  },
  props: [
    'id',
    'agency',
    'packageTitle',
    'property',
    'bookedBy',
    'bookedAt',
    'startDate',
    'endDate',
    'status',
    'associatedCampaignId',
    'type',
  ],
  mounted() {
    CampaignServiceV2.getAdminAssociatedCampaigns(this.id).then((r) => {
      if (r.data && r.data.data) {
        this.associatedCampaigns = r.data.data.map((obj) => ({
          id: obj.id,
          type: obj.type,
        }));
      }
    });
  },
};
</script>
